<template>
  <iColumn gap="large">
    <iColumn gap="none">
      <iTextInput
        v-model="firstName"
        label="First Name"
        placeholder="First Name"
        :disabled="isInviteUserLoading"
        type="text"
        width="fill"
        focus
        required
      />
      <iText v-if="firstNameValidationError" variant="error">
        {{ firstNameValidationError }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextInput
        v-model="lastName"
        label="Last Name"
        placeholder="Last Name"
        :disabled="isInviteUserLoading"
        type="text"
        width="fill"
        required
      />
      <iText v-if="lastNameValidationError" variant="error">
        {{ lastNameValidationError }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextInput
        v-model="email"
        label="Email"
        placeholder="Email"
        :disabled="isInviteUserLoading"
        type="email"
        width="fill"
        required
      />
      <iText v-if="emailValidationError" variant="error">
        {{ emailValidationError }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iButton
        v-if="showSubmitButton"
        :is-loading="isInviteUserLoading"
        size="standard"
        variant="primary"
        @click="inviteUserToPublication"
      >
        <iText v-if="addUserErrorMessage" variant="error">
          {{ addUserErrorMessage }}
        </iText>

        <iText v-else-if="!addUserErrorMessage" variant="light">
          Submit
        </iText>
      </iButton>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useInviteUserStore } from "@/stores/invite-user-store";

export default {
  name: "InvitePublicationUserForm",
  props: {
    showSubmitButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    publicationId: {
      type: Number,
      required: true,
    },
  },
  emits: ["add-user"],
  computed: {
    ...mapState(useInviteUserStore, [
      "isInviteUserLoading",
      "addUserErrorMessage",
    ]),
    ...mapWritableState(useInviteUserStore, [
      "firstName",
      "lastName",
      "email",
      "firstNameValidationError",
      "lastNameValidationError",
      "emailValidationError",
    ]),
  },
  methods: {
    inviteUserToPublication() {
      useInviteUserStore().inviteUser(this.publicationId, () => {
        this.$emit("add-user");
      });
    },
  },
};
</script>
